import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Payment = () => {
  const { registrationId } = useParams();
  const navigate = useNavigate();
  const [razorpayKey, setRazorpayKey] = useState("");
  const authtoken = localStorage.getItem("token");
  const rzpRef = useRef(null);

  const fetchRazorpayKey = async () => {
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/payment/registration/key",
        {
          method: "GET",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result.success && result.message?.data?.key) {
        const razorpayKey = result.message.data.key;
        setRazorpayKey(razorpayKey);
        createPaymentOrder(razorpayKey);
      } else {
        console.error("Failed to fetch Razorpay key");
      }
    } catch (error) {
      console.error("Error fetching key:", error);
    }
  };

  useEffect(() => {
    fetchRazorpayKey();
  }, []);

  const createPaymentOrder = async (razorpayKey) => {
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/payment/registration",
        {
          method: "POST",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            exam_date: "2024-08-01",
            start_time: "10:00:00",
            end_time: "12:00:00",
            student_capacity: 50,
            exam_id: 1,
          }),
        }
      );
      const result = await response.json();

      if (result.success && result.message?.paymentRes) {
        const { id: order_id } = result.message.paymentRes;
        loadRazorpay(razorpayKey, order_id);
      } else {
        console.error("Failed to create payment order");
      }
    } catch (error) {
      console.error("Error creating payment order:", error);
    }
  };

  // const loadRazorpay = (razorpayKey, order_id) => {
  //     const script = document.createElement("script");
  //     script.src = "https://checkout.razorpay.com/v1/checkout.js";
  //     script.async = true;
  //     document.body.appendChild(script);

  //     script.onload = () => {
  //         const options = {
  //             key: razorpayKey,
  //             amount: 100000,
  //             currency: "INR",
  //             name: "School App",
  //             description: "Registration Payment",
  //             order_id: order_id,
  //             handler: function (response) {
  //                 console.log("Payment success response:", response);
  //                 verifyPayment(response);

  //                 // Delay closing to ensure Razorpay processes payment
  //                 setTimeout(() => {
  //                     if (rzpRef.current) {
  //                         rzpRef.current.close();
  //                     }
  //                 }, 1000);
  //             },
  //             modal: {
  //                 ondismiss: function () {
  //                     console.log("Payment modal dismissed.");
  //                     window.location.replace("/myregistration");
  //                 }
  //             },
  //             prefill: {
  //                 name: "John Doe",
  //                 email: "johndoe@example.com",
  //                 contact: "9999999999",
  //             },
  //             theme: {
  //                 color: "#3399cc",
  //             },
  //         };

  //         rzpRef.current = window.Razorpay(options);
  //         rzpRef.current.open();
  //     };
  // };

  // const verifyPayment = async (paymentData) => {
  //     try {
  //         const response = await fetch(
  //             "https://api.mirai.healthcare/api/payment/registration/verify",
  //             {
  //                 method: "POST",
  //                 headers: {
  //                     'x-auth': `${authtoken}`,
  //                     "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify({
  //                     razorpay_payment_id: paymentData.razorpay_payment_id,
  //                     razorpay_order_id: paymentData.razorpay_order_id,
  //                     registration_id: registrationId,
  //                     razorpay_signature: paymentData.razorpay_signature,
  //                 }),
  //             }
  //         );
  //         const result = await response.json();
  //         if (result.success) {
  //             console.log("Payment verification successful:", result);

  //             // Ensure modal closes after successful payment verification
  //             if (rzpRef.current) {
  //                 rzpRef.current.close();
  //             }

  //             alert("Payment Successful!");
  //             rzpRef.current.close();
  //             navigate("/myregistration");
  //         } else {
  //             alert("Payment verification failed");
  //         }
  //     } catch (error) {
  //         console.error("Error verifying payment:", error);
  //     }
  // };

  const verifyPayment = async (paymentData) => {
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/payment/registration/verify",
        {
          method: "POST",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            razorpay_payment_id: paymentData.razorpay_payment_id,
            razorpay_order_id: paymentData.razorpay_order_id,
            registration_id: registrationId,
            razorpay_signature: paymentData.razorpay_signature,
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        console.log("Payment verification successful:", result);

        // Close Razorpay modal only after successful verification
        if (rzpRef.current) {
          rzpRef.current.close();
        }

        alert("Payment Successful!");
        rzpRef.current.close();
        navigate("/registration");
      } else {
        alert("Payment verification failed");
      }
    } catch (error) {
      console.error("Error verifying payment:", error);
    }
  };

  const loadRazorpay = (razorpayKey, order_id) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      const options = {
        key: razorpayKey,
        amount: 100000, // 1000 INR
        currency: "INR",
        name: "School App",
        description: "Registration Payment",
        order_id: order_id,
        handler: function (response) {
          console.log("Payment success response:", response);

          // Call verifyPayment and close modal only after success
          verifyPayment(response);
        },
        modal: {
          ondismiss: function () {
            console.log("Payment modal dismissed.");
            window.location.replace("/myregistration");
          },
        },
        prefill: {
          name: "John Doe",
          email: "johndoe@example.com",
          contact: "9999999999",
        },
        theme: {
          color: "#3399cc",
        },
      };

      rzpRef.current = new window.Razorpay(options);
      rzpRef.current.open();
    };
  };

  return <h2>Processing Payment...</h2>;
};

export default Payment;
